export function formatLifecycleStatus(status) {
	return String(status || "")
		.split("_")
		.filter(Boolean)
		.map((part) => part.charAt(0).toUpperCase() + part.slice(1))
		.join(" ");
}

export function lifecycleStatusOptions(currentStatus, allowedTransitions = []) {
	const statuses = [currentStatus, ...(Array.isArray(allowedTransitions) ? allowedTransitions : [])]
		.map((status) => String(status || "").trim())
		.filter(Boolean);

	return Array.from(new Set(statuses)).map((status) => ({
		value: status,
		label: formatLifecycleStatus(status),
	}));
}